export function StandartPlanIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={180}
            height={68}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 180 68"
        >
            <path
                d="M170.277 47.169h8.749V14.285h-8.749V47.17zm-.895-41.887c0-2.903 2.391-5.282 5.384-5.282C177.684 0 180 2.38 180 5.282s-2.32 5.281-5.234 5.281c-2.993 0-5.384-2.304-5.384-5.281zm-29.838 9.003L150.76 47.17h6.579l11.145-32.884h-5.234c-2.692 0-3.441.15-4.486 3.793l-4.486 15.475-4.711-15.475c-1.045-3.422-1.421-3.793-4.561-3.793h-5.462zm-24.157 22.84c0-3.572 3.215-4.687 6.88-4.687 2.918 0 5.46.3 7.851.894v2.753c-1.045 3.647-4.711 5.58-8.599 5.58-3.139-.002-6.132-1.416-6.132-4.54zm-8.749 0c0 7.216 4.936 10.788 12.49 10.788 5.609 0 10.17-2.009 12.339-5.951l1.046 5.207h5.685V25.294c0-8.11-4.561-12.127-14.434-12.127-3.666 0-7.554.224-10.994.969-3.591.744-3.591 2.008-3.591 4.687v3.718c3.065-1.04 8.377-2.233 13.311-2.233 4.861 0 7.628 1.71 7.628 6.325v.82a29.585 29.585 0 00-8.001-.895c-8.223.15-15.479 2.458-15.479 10.567zM92.805 47.17h9.197V2.454h-9.197v44.715zm-15.855 0h9.197V2.454H76.95v44.715zM64.237 52.97l3.59-1.934c1.422-.745 2.392-1.19 3.14-1.19 1.196 0 1.87.894 2.843 2.083 2.542 3.05 7.106 7.665 15.63 7.665 8.523 0 13.088-4.612 15.629-7.665.974-1.19 1.647-2.083 2.843-2.083.748 0 1.718.445 3.139 1.19l3.591 1.934C108.359 64.428 98.937 68 89.44 68c-9.498 0-18.92-3.572-25.203-15.03zM44.344 28.495c.448-4.837 4.038-7.74 9.723-7.74 5.159 0 8.377 2.978 8.377 7.74h-18.1zm-8.971 2.083c0 11.383 7.253 17.782 20.19 17.782 3.666 0 6.58-.298 9.197-.893 3.29-.745 3.813-1.414 3.813-4.687v-3.793c-3.516 1.19-7.926 1.859-11.817 1.859-7.106 0-11.291-2.233-12.115-6.397h25.876c.225-1.264.447-3.497.447-4.762 0-10.638-5.982-16.514-16.9-16.514-11.363-.007-18.691 6.838-18.691 17.405zM0 24.029c0 8.335 7.629 9.375 15.254 10.714 5.234.893 7.253 1.264 7.253 3.422 0 2.233-2.918 3.05-6.655 3.05-6.358 0-11.366-1.041-15.33-2.829v3.943c0 2.902 0 3.793 3.889 4.762 3.44.893 7.106 1.264 10.768 1.264 9.798 0 16.453-3.497 16.453-10.563 0-8.185-6.358-9.3-15.182-10.938-5.685-.968-7.403-1.19-7.403-3.348 0-1.934 2.169-3.049 6.955-3.049 4.339 0 10.919 1.414 13.013 2.53v-4.015c0-2.902-.075-3.718-3.888-4.687-2.917-.744-6.505-1.115-9.497-1.115C5.757 13.167 0 17.038 0 24.03z"
                fill="var(--primary-active)"
                className={fillClassName}
            />
        </svg>
    );
}

export function PlusPlanIcon({ mainClassName }) {
    return (
        <svg
            width={256}
            height={74}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 256 74"
        >
            <path
                d="M194.992 25.766a2.368 2.368 0 012.339-2.396l9.866-.12a2.369 2.369 0 002.34-2.396l-.111-9.127a2.37 2.37 0 012.34-2.397l6.169-.075a2.369 2.369 0 012.397 2.34l.11 9.127a2.368 2.368 0 002.397 2.34l9.866-.12a2.369 2.369 0 012.397 2.34l.075 6.169a2.37 2.37 0 01-2.34 2.397l-9.866.119a2.37 2.37 0 00-2.34 2.397l.111 9.126a2.369 2.369 0 01-2.34 2.397l-6.169.075a2.369 2.369 0 01-2.397-2.34l-.11-9.127a2.369 2.369 0 00-2.397-2.34l-9.866.12a2.369 2.369 0 01-2.397-2.34l-.074-6.169z"
                fill="#FFC02C"
            />
            <path
                d="M171.345 47.572h8.793V14.534h-8.793v33.038zm-.9-42.084c0-2.916 2.403-5.306 5.411-5.306 2.932 0 5.26 2.39 5.26 5.306s-2.331 5.307-5.26 5.307c-3.008 0-5.411-2.316-5.411-5.307zm-29.989 9.046l11.272 33.038h6.614l11.2-33.038h-5.26c-2.706 0-3.458.15-4.509 3.81l-4.508 15.548-4.735-15.547c-1.051-3.439-1.428-3.811-4.584-3.811h-5.49zM116.177 37.48c0-3.589 3.231-4.709 6.915-4.709 2.933 0 5.487.3 7.891.898v2.766c-1.051 3.664-4.735 5.607-8.643 5.607-3.155-.003-6.163-1.424-6.163-4.562zm-8.793 0c0 7.25 4.961 10.838 12.553 10.838 5.638 0 10.222-2.018 12.402-5.979l1.051 5.232h5.713V25.594c0-8.147-4.584-12.184-14.507-12.184-3.684 0-7.591.226-11.049.974-3.609.747-3.609 2.018-3.609 4.709v3.735c3.08-1.045 8.419-2.243 13.378-2.243 4.886 0 7.667 1.718 7.667 6.355v.823a29.76 29.76 0 00-8.042-.898c-8.265.15-15.557 2.468-15.557 10.616zm-13.903 10.09h9.243V2.648h-9.243v44.925zm-15.935 0h9.243V2.648h-9.243v44.925zm-12.777 5.83l3.609-1.943c1.428-.748 2.403-1.195 3.156-1.195 1.201 0 1.878.898 2.856 2.093 2.555 3.063 7.142 7.7 15.709 7.7s13.154-4.634 15.709-7.7c.978-1.196 1.654-2.093 2.856-2.093.752 0 1.727.447 3.156 1.195l3.608 1.943c-6.314 11.51-15.784 15.1-25.33 15.1-9.544 0-19.014-3.59-25.329-15.1zM44.776 28.81c.45-4.86 4.058-7.775 9.771-7.775 5.185 0 8.42 2.99 8.42 7.775H44.776zm-9.017 2.093c0 11.436 7.29 17.866 20.292 17.866 3.685 0 6.613-.3 9.244-.898 3.306-.748 3.832-1.42 3.832-4.709v-3.81c-3.533 1.194-7.966 1.867-11.877 1.867-7.142 0-11.348-2.243-12.176-6.426H71.08c.227-1.27.45-3.514.45-4.785 0-10.688-6.012-16.592-16.986-16.592-11.42-.006-18.785 6.87-18.785 17.487zM.208 24.324c0 8.373 7.667 9.418 15.33 10.763 5.26.898 7.29 1.27 7.29 3.439 0 2.243-2.932 3.063-6.688 3.063-6.39 0-11.424-1.045-15.407-2.84v3.96c0 2.916 0 3.811 3.907 4.784 3.458.898 7.142 1.27 10.823 1.27 9.848 0 16.536-3.513 16.536-10.612 0-8.223-6.39-9.343-15.259-10.99-5.713-.972-7.44-1.194-7.44-3.363 0-1.943 2.18-3.063 6.99-3.063 4.361 0 10.974 1.42 13.079 2.54v-4.032c0-2.916-.075-3.736-3.907-4.71-2.933-.747-6.538-1.12-9.546-1.12C5.993 13.412.208 17.3.208 24.325zM205.92 64.271a9.102 9.102 0 01-9.103 9.103 9.102 9.102 0 01-9.102-9.103 9.102 9.102 0 019.102-9.102 9.102 9.102 0 019.103 9.102zM227.16 63.007a7.838 7.838 0 11-15.676 0 7.838 7.838 0 1115.676 0zM244.859 56.686a6.574 6.574 0 11-13.149-.001 6.574 6.574 0 0113.149 0zM252.444 45.308c0 2.653-2.264 4.804-5.057 4.804-2.793 0-5.057-2.15-5.057-4.804 0-2.653 2.264-4.804 5.057-4.804 2.793 0 5.057 2.15 5.057 4.804zM255.984 33.677a4.298 4.298 0 11-8.596 0 4.298 4.298 0 018.596 0zM253.961 22.804c0 1.676-1.471 3.034-3.287 3.034-1.815 0-3.287-1.358-3.287-3.034 0-1.675 1.472-3.034 3.287-3.034 1.816 0 3.287 1.358 3.287 3.034z"
                fill="var(--primary-active)"
            />
        </svg>
    );
}


export function TickKeyPointIcon({ mainClassName }) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 24"
        >
            <path
                d="M10.5 19.5a1.976 1.976 0 01-1.268-.453L2.42 13.188a.754.754 0 01-.092-1.043l1.582-1.937a.75.75 0 011.073-.092l5.318 4.617 8.55-9.386a.75.75 0 011.054-.055l1.864 1.673a.75.75 0 01.055 1.062l-9.833 10.81a2.02 2.02 0 01-1.49.663z"
                fill="url(#prefix__paint0_linear_215_16404)"
            />
            <defs>
                <linearGradient
                    id="prefix__paint0_linear_215_16404"
                    x1={12.087}
                    y1={5.102}
                    x2={12.087}
                    y2={19.5}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0.278} stopColor="#65E04D" />
                    <stop offset={0.458} stopColor="#5CD740" />
                    <stop offset={0.79} stopColor="#44C11D" />
                    <stop offset={1} stopColor="#33B004" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function PlusPointIcon({ mainClassName }) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 24"
        >
            <path
                d="M22 12c0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10C2 6.478 6.478 2 12 2c5.523 0 10 4.478 10 10z"
                fill="var(--primary-active)"
            />
            <path
                opacity={0.05}
                d="M17 10.5h-3.5V7a1 1 0 00-1-1h-1a1 1 0 00-1 1v3.5H7a1 1 0 00-1 1v1a1 1 0 001 1h3.5V17a1 1 0 001 1h1a1 1 0 001-1v-3.5H17a1 1 0 001-1v-1a1 1 0 00-1-1z"
                fill="var(--neutral-active)"
            />
            <path
                opacity={0.07}
                d="M17 10.75h-3.75V7a.75.75 0 00-.75-.75h-1a.75.75 0 00-.75.75v3.75H7a.75.75 0 00-.75.75v1c0 .414.336.75.75.75h3.75V17c0 .414.336.75.75.75h1a.75.75 0 00.75-.75v-3.75H17a.75.75 0 00.75-.75v-1a.75.75 0 00-.75-.75z"
                fill="var(--neutral-active)"
            />
            <path
                d="M11.5 6.5h1a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7a.5.5 0 01.5-.5z"
                fill="#fff"
            />
            <path
                d="M17.5 11.5v1a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5v-1A.5.5 0 017 11h10a.5.5 0 01.5.5z"
                fill="#fff"
            />
        </svg>
    );
}

export function DropArrowIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 24 24"
        >
            <path
                d="M6 9l6 6 6-6"
                stroke="var(--neutral-active)"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}


export function SellaviPointIcon({ mainClassName, }) {
    return (
        <svg
            width={45}
            height={45}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 45 45"
        >
            <path
                d="M22.5 39.375c9.32 0 16.875-7.555 16.875-16.875S31.82 5.625 22.5 5.625 5.625 13.18 5.625 22.5 13.18 39.375 22.5 39.375z"
                fill="var(--primary-active)"
                stroke="var(--primary-active)"
                strokeWidth={1.473}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.573 26.014h2.932V12.857h-2.932v13.157zm-5.055 0h2.932V12.857h-2.932v13.157zm-4.054 1.707l1.145-.57c.453-.218.763-.35 1.001-.35.381 0 .596.264.907.614.81.897 2.265 2.255 4.983 2.255 2.718 0 4.173-1.357 4.984-2.255.31-.35.525-.613.906-.613.238 0 .548.13 1.001.35l1.145.569c-2.003 3.37-5.008 4.422-8.036 4.422-3.028 0-6.032-1.051-8.036-4.422z"
                fill="var(--primary-text)"
            />
        </svg>
    );
}
